import { Button } from '@components/ui';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import React from 'react';

import styles from './DetailPageLayout.module.scss';

interface DetailPageLayoutProps {
  backLabel: string;
  backHref: string;
  header: React.ReactNode;
  tabs?: React.ReactNode;
  children: React.ReactNode;
}

export const DetailPageLayout: React.FC<DetailPageLayoutProps> = ({ backLabel, backHref, header, tabs, children }) => {
  const { push } = useRouter();

  return (
    <div className={styles.root}>
      <Button
        view="secondary"
        size="small"
        className={styles.backButton}
        onClick={() => push(backHref)}
        type="button"
      >
        ← {backLabel}
      </Button>
      <div className={clsx({ [styles.headerSpacing]: !tabs })}>{header}</div>
      {tabs && <div className={styles.tabs}>{tabs}</div>}
      <div className={styles.content}>{children}</div>
    </div>
  );
};
